module.exports = __webpack_public_path__ + "img/background_c4-1.397fddb5.jpg";